module.exports = __webpack_public_path__ + "img/026-sewing.387e7ad3.svg";